import { createRouter, createWebHistory } from 'vue-router'
import Layout from '../views/Layout/MainLayout.vue'
import Home from '../views/Home/'
import NewInfoDetail from '../views/NewInfoDetail/'
import DataDemandSide from '@/views/Home/components/dataInfo/DataDemandSide.vue'
import DataServiceProviderView from '@/views/Home/components/dataInfo/DataServiceProviderView.vue'
import DataRequirementRequest from '@/views/Home/components/dataInfo/DataRequirementRequest.vue'
import AddExpert from '@/views/Layout/components/Header/components/AddExpert.vue'
import AddCompanyInfo from '@/views/Layout/components/Header/components/AddCompanyInfo.vue'
import DataTradingInfo from '@/views/Home/components/dataInfo/DataTradingInfo.vue'
import DataTradingInfoList from '@/views/Home/components/dataInfo/DataTradingInfoList.vue'
import DataProviderDetails from '@/views/Home/components/dataInfo/DataProviderDetails.vue'
import InterViewList from '@/components/Interview/InterViewList.vue'
import InterViewDetail from '@/components/Interview/InterViewDetail.vue'
import LiveInfoMore from '@/components/LiveInfo/LiveInfoMore.vue'
import UserDetailMore from '@/components/UserDetail/UserDetailMore.vue'
import UserDetailName from '@/components/UserDetail/UserDetailName.vue'
import FooterDetail from '@/views/Home/components/Footer/FooterDetail.vue'
import DataChangeList from '@/components/DataChange/DataChangeList.vue'
import DataChangedetail from '@/components/DataChange/DataChangedetail.vue'
import DatasetDetail from '@/components/DataSet/DatasetDetail.vue'
import ListingDetailView from '@/views/Home/components/dataInfo/ListingDetailView.vue'
import chinaIndex from '@/components/ChinaMap/chinaIndex.vue'
import ProviderMapIndex from '@/components/ChinaMap/ProviderMapIndex.vue'
import HotNewsList from '@/components/NewsDetail/HotNewsList.vue'
import EnterpriseArchive from '@/views/EnterpriseArchive/index.vue'
import IndustryInfo from '@/components/IndustryInfo'
import SimpleBoard from '@/views/SimpleBoard'
import { P, dropQuery, hasQuery, isLegacyPath, keepsQuery } from './paths'
import { businessPilotEnabled } from '@/config/business'

const routes = [
  ...(businessPilotEnabled ? [{ path: '/trade-workbench/:tab?', redirect: (to) => ({ path: ({ seller: '/datasets/register', catalog: '/datasets/verification', buyer: '/demand/assistant', leads: '/hall/progress', plan: '/datasets/collection-plan' })[to.params.tab] || '/datasets/register' }) }] : []),
  {
    path: '/',
    component: Layout,
    children: [
      ...(businessPilotEnabled ? [
        ['datasets/register', 'seller', '数据集登记与初评'],
        ['datasets/verification', 'catalog', '供给核验'],
        ['demand/assistant', 'buyer', '采购需求与匹配'],
        ['hall/progress', 'leads', '我的交易跟进'],
        ['datasets/collection-plan', 'plan', '企业数据采集规划'],
      ].map(([path, businessTab, title]) => ({ path, component: () => import('@/views/TradeWorkbench/index.vue'), meta: { businessTab, title, breadcrumb: [{ title: '首页', path: '/' }, { title }] } })) : []),
      {
        path: '',
        name: 'Home',
        component: Home,
        meta: { title: '首页' }
      },
      {
        path: 'enterprises',
        name: 'Enterprises',
        component: EnterpriseArchive,
        meta: {
          title: '企业资料',
          breadcrumb: [
            { title: '首页', path: P.home },
            { title: '企业资料', path: P.enterprises }
          ]
        }
      },
      {
        path: 'news',
        name: 'News',
        component: HotNewsList,
        meta: {
          title: '资讯',
          breadcrumb: [
            { title: '首页', path: P.home },
            { title: '资讯', path: P.news }
          ]
        }
      },
      {
        // 旧地址保留：/news/express 等价于「24H快报」tab
        path: 'news/express',
        redirect: () => ({ path: P.news, query: { type: '1' } })
      },
      {
        path: 'news/:id',
        name: 'NewsDetail',
        component: NewInfoDetail,
        meta: {
          title: '新闻详情',
          breadcrumb: [
            { title: '首页', path: P.home },
            { title: '热点资讯', path: P.news },
            { title: '新闻详情' }
          ]
        }
      },
      {
        path: 'hall',
        name: 'Hall',
        component: DataChangeList,
        meta: {
          title: '数据交易大厅',
          breadcrumb: [
            { title: '首页', path: P.home },
            { title: '数据交易大厅', path: P.hall }
          ]
        }
      },
      {
        path: 'hall/:id',
        name: 'HallDetail',
        component: DataChangedetail,
        meta: {
          title: '交易详情',
          breadcrumb: [
            { title: '首页', path: P.home },
            { title: '数据交易大厅', path: P.hall },
            { title: '交易详情' }
          ]
        }
      },
      {
        path: 'datasets',
        name: 'Datasets',
        component: DataDemandSide,
        meta: {
          title: '数据集',
          listType: 3,
          breadcrumb: [
            { title: '首页', path: P.home },
            { title: '数据集', path: P.datasets }
          ]
        }
      },
      {
        path: 'datasets/:id',
        name: 'DatasetDetail',
        component: DatasetDetail,
        meta: {
          title: '数据集详情',
          breadcrumb: [
            { title: '首页', path: P.home },
            { title: '数据集', path: P.datasets },
            { title: '详情' }
          ]
        }
      },
      {
        path: 'providers',
        name: 'Providers',
        component: DataDemandSide,
        meta: {
          title: '数据服务商',
          listType: 2,
          breadcrumb: [
            { title: '首页', path: P.home },
            { title: '数据服务商', path: P.providers }
          ]
        }
      },
      {
        path: 'providers/apply',
        name: 'ProviderApply',
        component: DataRequirementRequest,
        meta: {
          title: '数据服务登记',
          listType: 2,
          breadcrumb: [
            { title: '首页', path: P.home },
            { title: '数据服务登记', path: P.providerApply }
          ]
        }
      },
      {
        path: 'providers/card/:id',
        name: 'ProviderCard',
        component: ListingDetailView,
        meta: {
          title: '供需入驻',
          listType: 2,
          breadcrumb: [
            { title: '首页', path: P.home },
            { title: '数据服务商', path: P.providers },
            { title: '入驻详情' }
          ]
        }
      },
      {
        path: 'enterprise/:id',
        name: 'EnterpriseDetail',
        component: DataServiceProviderView,
        meta: {
          title: '企业信息',
          breadcrumb: [
            { title: '首页', path: P.home },
            { title: '企业信息' }
          ]
        }
      },
      {
        path: 'providers/:id/:companyId?',
        name: 'ProviderDetail',
        component: DataServiceProviderView,
        meta: {
          title: '企业信息',
          breadcrumb: [
            { title: '首页', path: P.home },
            { title: '数据服务商', path: P.providers },
            { title: '企业信息' }
          ]
        }
      },
      {
        path: 'demand',
        name: 'Demand',
        component: DataDemandSide,
        meta: {
          title: '数据需求方',
          listType: 1,
          breadcrumb: [
            { title: '首页', path: P.home },
            { title: '数据需求方', path: P.demand }
          ]
        }
      },
      {
        path: 'demand/apply',
        name: 'DemandApply',
        component: DataRequirementRequest,
        meta: {
          title: '数据需求申请',
          listType: 1,
          breadcrumb: [
            { title: '首页', path: P.home },
            { title: '数据需求申请', path: P.demandApply }
          ]
        }
      },
      {
        path: 'demand/:id',
        name: 'DemandDetail',
        component: ListingDetailView,
        meta: {
          title: '供需入驻',
          listType: 1,
          breadcrumb: [
            { title: '首页', path: P.home },
            { title: '数据需求方', path: P.demand },
            { title: '入驻详情' }
          ]
        }
      },
      {
        path: 'exchanges',
        name: 'Exchanges',
        component: DataTradingInfoList,
        meta: {
          title: '数据交易所',
          breadcrumb: [
            { title: '首页', path: P.home },
            { title: '数据交易所', path: P.exchanges }
          ]
        }
      },
      {
        path: 'exchanges/apply',
        name: 'ExchangeApply',
        component: DataTradingInfo,
        meta: {
          title: '数据交易所申请',
          breadcrumb: [
            { title: '首页', path: P.home },
            { title: '数据交易所申请', path: P.exchangeApply }
          ]
        }
      },
      {
        path: 'map',
        name: 'Map',
        component: chinaIndex,
        meta: {
          title: '数据地图',
          breadcrumb: [
            { title: '首页', path: P.home },
            { title: '数据地图', path: P.map }
          ]
        }
      },
      {
        path: 'map/:name',
        name: 'MapRegion',
        component: ProviderMapIndex,
        meta: {
          title: '省级地图',
          breadcrumb: [
            { title: '首页', path: P.home },
            { title: '数据地图', path: P.map },
            { title: '省级地图' }
          ]
        }
      },
      {
        path: 'experts',
        name: 'Experts',
        component: InterViewList,
        meta: {
          title: '数据产业专家库',
          desc: '查找已公开的数据产业专家资料与研究方向。',
          breadcrumb: [
            { title: '首页', path: P.home },
            { title: '数据产业专家库', path: P.experts }
          ]
        }
      },
      {
        path: 'experts/:id',
        name: 'ExpertDetail',
        component: InterViewDetail,
        meta: {
          title: '专家详情',
          breadcrumb: [
            { title: '首页', path: P.home },
            { title: '数据产业专家库', path: P.experts },
            { title: '专家详情' }
          ]
        }
      },
      {
        path: 'interviews',
        name: 'Interviews',
        component: UserDetailMore,
        meta: {
          title: '数匠领袖',
          desc: '专家观点、行业观察与一线实践。',
          breadcrumb: [
            { title: '首页', path: P.home },
            { title: '数匠领袖', path: P.interviews }
          ]
        }
      },
      {
        path: 'interviews/:id',
        name: 'InterviewDetail',
        component: UserDetailName,
        meta: {
          title: '专家详情',
          breadcrumb: [
            { title: '首页', path: P.home },
            { title: '数匠领袖', path: P.interviews },
            { title: '专家详情' }
          ]
        }
      },
      {
        path: 'live',
        name: 'Live',
        component: LiveInfoMore,
        meta: {
          title: '直播活动',
          breadcrumb: [
            { title: '首页', path: P.home },
            { title: '直播活动', path: P.live }
          ]
        }
      },
      {
        path: 'resources',
        name: 'Resources',
        component: IndustryInfo,
        meta: {
          title: '行业资料',
          breadcrumb: [
            { title: '首页', path: P.home },
            { title: '行业资料', path: P.resources }
          ]
        }
      },
      {
        path: 'submit/company',
        name: 'SubmitCompany',
        component: AddCompanyInfo,
        meta: {
          title: '企业信息申请',
          breadcrumb: [
            { title: '首页', path: P.home },
            { title: '企业信息申请', path: P.submitCompany }
          ]
        }
      },
      {
        path: 'submit/expert',
        name: 'SubmitExpert',
        component: AddExpert,
        meta: {
          title: '专家库申请',
          breadcrumb: [
            { title: '首页', path: P.home },
            { title: '专家库申请', path: P.submitExpert }
          ]
        }
      },
      {
        path: 'college',
        name: 'College',
        component: SimpleBoard,
        meta: {
          title: '数据资产商学院',
          desc: '1.0 先保留入口，课程与报名能力后续上线。',
          breadcrumb: [
            { title: '首页', path: P.home },
            { title: '数据资产商学院', path: P.college }
          ]
        }
      },
      {
        path: 'lab',
        name: 'Lab',
        component: SimpleBoard,
        meta: {
          title: '国数探索实验室',
          desc: '1.0 先保留入口，实验室完整产品后续上线。',
          breadcrumb: [
            { title: '首页', path: P.home },
            { title: '国数探索实验室', path: P.lab }
          ]
        }
      },
      {
        path: 'about/:name?',
        name: 'About',
        component: FooterDetail,
        meta: {
          title: '关于',
          breadcrumb: [
            { title: '首页', path: P.home },
            { title: '关于' }
          ]
        }
      },
      {
        path: 'supplier/:id/:companyId?',
        name: 'SupplierDetail',
        component: DataProviderDetails,
        meta: {
          title: '企业信息',
          breadcrumb: [
            { title: '首页', path: P.home },
            { title: '企业信息' }
          ]
        }
      }
    ]
  },
  { path: '/Home', redirect: () => ({ path: P.home, query: {} }) },
  {
    // 后台「预览」用：用官网自己的组件渲染后台当前这条记录（不带站点头尾）
    path: '/preview/:kind/:id',
    name: 'SitePreview',
    component: () => import('@/views/SitePreview/index.vue'),
    meta: { title: '官网预览' }
  },
  { path: '/HotNewsList', redirect: (to) => ({ path: P.news, query: to.query.type ? { type: String(to.query.type) } : {} }) },
  { path: '/moreDetail', redirect: (to) => ({ path: P.news, query: to.query.type ? { type: String(to.query.type) } : {} }) },
  { path: '/NewInfoDetail', redirect: (to) => ({ path: P.newsDetail(to.query.id), query: {} }) },
  { path: '/DataChangeList', redirect: () => ({ path: P.hall, query: {} }) },
  { path: '/DataChangedetail', redirect: (to) => ({ path: P.hallDetail(to.query.Id || to.query.id), query: {} }) },
  { path: '/DataDemandSide', redirect: (to) => {
    const type = Number(to.query.type)
    const path = (type === 3 || to.query.title === '数据集') ? P.datasets : (type === 1 ? P.demand : P.providers)
    return { path, query: {} }
  }},
  { path: '/DataServiceProviderView', redirect: (to) => ({ path: P.providerDetail(to.query.enterpriseId || to.query.Id, to.query.companyId || to.query.Id), query: {} }) },
  { path: '/DataProviderDetails', redirect: (to) => ({ path: P.supplier(to.query.enterpriseId || to.query.Id || to.query.id, to.query.companyId), query: {} }) },
  { path: '/DataRequirementRequest', redirect: (to) => ({ path: Number(to.query.type) === 2 ? P.providerApply : P.demandApply, query: {} }) },
  { path: '/DataTradingInfoList', redirect: () => ({ path: P.exchanges, query: {} }) },
  { path: '/DataTradingInfo', redirect: () => ({ path: P.exchangeApply, query: {} }) },
  { path: '/chinaIndex', redirect: () => ({ path: P.map, query: {} }) },
  { path: '/ProviderMapIndex', redirect: (to) => ({ path: P.mapRegion(to.query.name), query: {} }) },
  { path: '/InterViewList', redirect: () => ({ path: P.experts, query: {} }) },
  { path: '/InterViewDetail', redirect: (to) => ({ path: P.expertDetail(to.query.Id || to.query.id), query: {} }) },
  { path: '/UserDetailMore', redirect: () => ({ path: P.interviews, query: {} }) },
  { path: '/UserDetailName', redirect: (to) => ({ path: P.interviewDetail(to.query.Id || to.query.id), query: {} }) },
  { path: '/LiveInfoMore', redirect: () => ({ path: P.live, query: {} }) },
  { path: '/IndustryInfo', redirect: () => ({ path: P.resources, query: {} }) },
  { path: '/AddCompanyInfo', redirect: () => ({ path: P.submitCompany, query: {} }) },
  { path: '/AddExpert', redirect: () => ({ path: P.submitExpert, query: {} }) },
  { path: '/College', redirect: () => ({ path: P.college, query: {} }) },
  { path: '/Lab', redirect: () => ({ path: P.lab, query: {} }) },
  { path: '/FooterDetail', redirect: (to) => ({ path: P.about(to.query.name), query: {} }) }
]

function scrollPageTop() {
  window.scrollTo(0, 0)
  document.documentElement.scrollTop = 0
  document.body.scrollTop = 0
  const main = document.querySelector('.el-main')
  if (main) main.scrollTop = 0
}

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // 带锚点的跳转交给原生：滚到对应 id（位置由 CSS scroll-margin-top 让开导航）
    if (to.hash) {
      const id = decodeURIComponent(to.hash.slice(1))
      return { el: document.getElementById(id) ? `#${CSS.escape(id)}` : undefined, top: 0, behavior: 'smooth' }
    }
    if (savedPosition) return savedPosition
    return { left: 0, top: 0 }
  }
})

router.beforeEach((to, from, next) => {
  if (isLegacyPath(to.path)) {
    next()
    return
  }
  // 预览页用 ?view= 控制列表卡片 / 详情内容，查询串必须保留
  if (to.path.startsWith('/preview/')) {
    next()
    return
  }
  if (hasQuery(to) && !keepsQuery(to)) {
    next(dropQuery(to))
    return
  }
  next()
})

router.afterEach((to) => {
  if (to.hash) return
  scrollPageTop()
  requestAnimationFrame(scrollPageTop)
})

export default router
